<aside class="  ">
  <div class=" d-flex justify-content-center">
    <div id="carouselExampleIndicators" class=" carousel slide row  " 
      data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
      </ol>
      <div class="carousel-inner " [ngSwitch]="idioma">
        <ng-container *ngSwitchCase="'2'">
          <div class="carousel-item {{data2.activo}}" *ngFor='let data2 of data2[0].default.UsatGaleria '>
          <img src="{{data2.imagenEn}}" class="{{data2.tamano}} d-block " alt="...">
          <div class="carousel-caption d-none d-md-block">
            <!-- <h5>First slide label</h5>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
          </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchCase="'3'">
          <div class="carousel-item {{data2.activo}}" *ngFor='let data2 of data2[0].default.UsatGaleria '>
          <img src="{{data2.imagenZh}}" class="{{data2.tamano}} d-block " alt="...">
          <div class="carousel-caption d-none d-md-block">
            <!-- <h5>First slide label</h5>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
          </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchCase="'4'">
          <div class="carousel-item {{data2.activo}}" *ngFor='let data2 of data2[0].default.UsatGaleria '>
          <img src="{{data2.imagenFr}}" class="{{data2.tamano}} d-block " alt="...">
          <div class="carousel-caption d-none d-md-block">
            <!-- <h5>First slide label</h5>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
          </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchCase="'5'">
          <div class="carousel-item {{data2.activo}}" *ngFor='let data2 of data2[0].default.UsatGaleria '>
          <img src="{{data2.imagenDe}}" class="{{data2.tamano}} d-block " alt="...">
          <div class="carousel-caption d-none d-md-block">
            <!-- <h5>First slide label</h5>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
          </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchCase="'6'">
          <div class="carousel-item {{data2.activo}}" *ngFor='let data2 of data2[0].default.UsatGaleria '>
          <img src="{{data2.imagenRu}}" class="{{data2.tamano}} d-block " alt="...">
          <div class="carousel-caption d-none d-md-block">
            <!-- <h5>First slide label</h5>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
          </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchCase="'7'">
          <div class="carousel-item {{data2.activo}}" *ngFor='let data2 of data2[0].default.UsatGaleria '>
          <img src="{{data2.imagenBr}}" class="{{data2.tamano}} d-block " alt="...">
          <div class="carousel-caption d-none d-md-block">
            <!-- <h5>First slide label</h5>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
          </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchCase="'8'">
          <div class="carousel-item {{data2.activo}}" *ngFor='let data2 of data2[0].default.UsatGaleria '>
          <img src="{{data2.imagenKr}}" class="{{data2.tamano}} d-block " alt="...">
          <div class="carousel-caption d-none d-md-block">
            <!-- <h5>First slide label</h5>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
          </div>
        </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="carousel-item {{data2.activo}}" *ngFor='let data2 of data2[0].default.UsatGaleria '>
          <img src="{{data2.imagen}}" class="{{data2.tamano}} d-block " alt="...">
          <div class="carousel-caption d-none d-md-block">
            <!-- <h5>First slide label</h5>
            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
          </div>
        </div>
        </ng-container> 
      </div>
      <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</aside>
<aside class="container">
  <!-- Collacsable -->
  <div class="row contenidoGIf">

    <div class=" col-lg-6 col-12 collapseM">
      <div class="row" [ngSwitch]="idioma">
        <ng-container *ngSwitchCase="'2'">
          <!-- *************************************************************************Caso en ingles********************************************************************** -->
          <div class="col-lg-12 col-12">
            <div class="accordion" id="accordionExample" *ngFor='let UsatCharac of data2[0].default.UsatCharac'>
              <div class="card">
                <div class="card-header" id="{{UsatCharac.idHeading}}">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                      [attr.data-target]="'#' + UsatCharac.idCollapse" [attr.aria-expanded]="UsatCharac.expanded"
                      [attr.aria-controls]="UsatCharac.idCollapse">
                      {{UsatCharac.tituloIn}}
                    </button>
                  </h2>
                </div>

                <div id="{{UsatCharac.idCollapse}}" class="collapse {{UsatCharac.show}}"
                  [attr.aria-labelledby]="UsatCharac.idHeading" data-parent="#accordionExample">
                  <div class="card-body">
                    {{UsatCharac.descripcionIn}}
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseSeven"
                      aria-expanded="true" aria-controls="collapseSeven">
                      Technical specifications
                    </button>
                  </h2>
                </div>

                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                  <div class="card-body">
                    <table class=" table table-bordered table-hover">
                      <tr>
                        <th scope="">Characteristic</th>
                        <th scope="">Description</th>
                      </tr>

                      <tr *ngFor='let tabla of data.default.tablaUsat'>
                        <th scope="">{{tabla.tCaracteristica1In}}</th>
                        <td scope="">{{tabla.tEspecificacion1In}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'3'">
          <!-- *************************************************************************Caso en Chino*********************************************************************** -->
          <div class="col-lg-12 col-12">
            <div class="accordion" id="accordionExample" *ngFor='let UsatCharac of data2[0].default.UsatCharac'>
              <div class="card">
                <div class="card-header" id="{{UsatCharac.idHeading}}">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                      [attr.data-target]="'#' + UsatCharac.idCollapse" [attr.aria-expanded]="UsatCharac.expanded"
                      [attr.aria-controls]="UsatCharac.idCollapse">
                      {{UsatCharac.tituloZh}}
                    </button>
                  </h2>
                </div>

                <div id="{{UsatCharac.idCollapse}}" class="collapse {{UsatCharac.show}}"
                  [attr.aria-labelledby]="UsatCharac.idHeading" data-parent="#accordionExample">
                  <div class="card-body">
                    {{UsatCharac.descripcionZh}} 
                    <!-- Idiomas -->
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseSeven"
                      aria-expanded="true" aria-controls="collapseSeven">
                      技術指標
                    </button>
                  </h2>
                </div>

                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                  <div class="card-body">
                    <table class=" table table-bordered table-hover">
                      <tr>
                        <th scope="">特色</th>
                        <th scope="">內容描述</th>
                      </tr>
                      <tr *ngFor='let tabla of data.default.tablaUsat'>
                        <th scope="">{{tabla.tCaracteristica1Zh}}</th>
                        <td scope="">{{tabla.tEspecificacion1Zh}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- *************************************************************************Caso en español********************************************************************** -->
        <ng-container *ngSwitchDefault>
          <div class="col-lg-12 col-12">
            <div class="accordion" id="accordionExample" *ngFor='let UsatCharac of data2[0].default.UsatCharac'>
              <div class="card">
                <div class="card-header" id="{{UsatCharac.idHeading}}">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                      [attr.data-target]="'#' + UsatCharac.idCollapse" [attr.aria-expanded]="UsatCharac.expanded"
                      [attr.aria-controls]="UsatCharac.idCollapse">
                      {{UsatCharac.titulo}}
                    </button>
                  </h2>
                </div>

                <div id="{{UsatCharac.idCollapse}}" class="collapse {{UsatCharac.show}}"
                  [attr.aria-labelledby]="UsatCharac.idHeading" data-parent="#accordionExample">
                  <div class="card-body">
                    {{UsatCharac.descripcion}}
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseSeven"
                      aria-expanded="true" aria-controls="collapseSeven">
                      Especificaciones técnicas
                    </button>
                  </h2>
                </div>

                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                  <div class="card-body">
                    <table class=" table table-bordered table-hover">
                      <tr>
                        <th scope="">Característica</th>
                        <th scope="">Descripción</th>
                      </tr>
                      <tr *ngFor='let tabla of data.default.tablaUsat'>
                        <th scope="">{{tabla.tCaracteristica1}}</th>
                        <td scope="">{{tabla.tEspecificacion1}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'4'">
          <!-- *************************************************************************Caso en Frances********************************************************************** -->
          <div class="col-lg-12 col-12">
            <div class="accordion" id="accordionExample" *ngFor='let UsatCharac of data2[0].default.UsatCharac'>
              <div class="card">
                <div class="card-header" id="{{UsatCharac.idHeading}}">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                      [attr.data-target]="'#' + UsatCharac.idCollapse" [attr.aria-expanded]="UsatCharac.expanded"
                      [attr.aria-controls]="UsatCharac.idCollapse">
                      {{UsatCharac.tituloFr}}
                    </button>
                  </h2>
                </div>

                <div id="{{UsatCharac.idCollapse}}" class="collapse {{UsatCharac.show}}"
                  [attr.aria-labelledby]="UsatCharac.idHeading" data-parent="#accordionExample">
                  <div class="card-body">
                    {{UsatCharac.descripcionFr}}
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseSeven"
                      aria-expanded="true" aria-controls="collapseSeven">
                      Spécifications techniques
                    </button>
                  </h2>
                </div>

                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                  <div class="card-body">
                    <table class=" table table-bordered table-hover">
                      <tr>
                        <th scope="">Caractéristique</th>
                        <th scope="">la description</th>
                      </tr>

                      <tr *ngFor='let tabla of data.default.tablaUsat'>
                        <th scope="">{{tabla.tCaracteristica1Fr}}</th>
                        <td scope="">{{tabla.tEspecificacion1Fr}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'5'">
          <!-- *************************************************************************Caso en Aleman********************************************************************** -->
          <div class="col-lg-12 col-12">
            <div class="accordion" id="accordionExample" *ngFor='let UsatCharac of data2[0].default.UsatCharac'>
              <div class="card">
                <div class="card-header" id="{{UsatCharac.idHeading}}">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                      [attr.data-target]="'#' + UsatCharac.idCollapse" [attr.aria-expanded]="UsatCharac.expanded"
                      [attr.aria-controls]="UsatCharac.idCollapse">
                      {{UsatCharac.tituloDe}}
                    </button>
                  </h2>
                </div>

                <div id="{{UsatCharac.idCollapse}}" class="collapse {{UsatCharac.show}}"
                  [attr.aria-labelledby]="UsatCharac.idHeading" data-parent="#accordionExample">
                  <div class="card-body">
                    {{UsatCharac.descripcionDe}}
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseSeven"
                      aria-expanded="true" aria-controls="collapseSeven">
                      Technische Spezifikationen
                    </button>
                  </h2>
                </div>

                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                  <div class="card-body">
                    <table class=" table table-bordered table-hover">
                      <tr>
                        <th scope="">Eigenschaften</th>
                        <th scope="">Beschreibung</th>
                      </tr>

                      <tr *ngFor='let tabla of data.default.tablaUsat'>
                        <th scope="">{{tabla.tCaracteristica1De}}</th>
                        <td scope="">{{tabla.tEspecificacion1De}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'6'">
          <!-- *************************************************************************Caso en Ruso********************************************************************** -->
          <div class="col-lg-12 col-12">
            <div class="accordion" id="accordionExample" *ngFor='let UsatCharac of data2[0].default.UsatCharac'>
              <div class="card">
                <div class="card-header" id="{{UsatCharac.idHeading}}">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                      [attr.data-target]="'#' + UsatCharac.idCollapse" [attr.aria-expanded]="UsatCharac.expanded"
                      [attr.aria-controls]="UsatCharac.idCollapse">
                      {{UsatCharac.tituloRu}}
                    </button>
                  </h2>
                </div>

                <div id="{{UsatCharac.idCollapse}}" class="collapse {{UsatCharac.show}}"
                  [attr.aria-labelledby]="UsatCharac.idHeading" data-parent="#accordionExample">
                  <div class="card-body">
                    {{UsatCharac.descripcionRu}}
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseSeven"
                      aria-expanded="true" aria-controls="collapseSeven">
                      Технические характеристики
                    </button>
                  </h2>
                </div>

                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                  <div class="card-body">
                    <table class=" table table-bordered table-hover">
                      <tr>
                        <th scope="">характеристики</th>
                        <th scope="">Описание</th>
                      </tr>

                      <tr *ngFor='let tabla of data.default.tablaUsat'>
                        <th scope="">{{tabla.tCaracteristica1Ru}}</th>
                        <td scope="">{{tabla.tEspecificacion1Ru}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'7'">
          <!-- *************************************************************************Caso en Portugués Brasil********************************************************************** -->
          <div class="col-lg-12 col-12">
            <div class="accordion" id="accordionExample" *ngFor='let UsatCharac of data2[0].default.UsatCharac'>
              <div class="card">
                <div class="card-header" id="{{UsatCharac.idHeading}}">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                      [attr.data-target]="'#' + UsatCharac.idCollapse" [attr.aria-expanded]="UsatCharac.expanded"
                      [attr.aria-controls]="UsatCharac.idCollapse">
                      {{UsatCharac.tituloBr}}
                    </button>
                  </h2>
                </div>

                <div id="{{UsatCharac.idCollapse}}" class="collapse {{UsatCharac.show}}"
                  [attr.aria-labelledby]="UsatCharac.idHeading" data-parent="#accordionExample">
                  <div class="card-body">
                    {{UsatCharac.descripcionBr}}
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseSeven"
                      aria-expanded="true" aria-controls="collapseSeven">
                      Especificações técnicas
                    </button>
                  </h2>
                </div>

                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                  <div class="card-body">
                    <table class=" table table-bordered table-hover">
                      <tr>
                        <th scope="">Recurso</th>
                        <th scope="">Descrição</th>
                      </tr>

                      <tr *ngFor='let tabla of data.default.tablaUsat'>
                        <th scope="">{{tabla.tCaracteristica1Br}}</th>
                        <td scope="">{{tabla.tEspecificacion1Br}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'8'">
          <!-- *************************************************************************Caso en Coreano********************************************************************** -->
          <div class="col-lg-12 col-12">
            <div class="accordion" id="accordionExample" *ngFor='let UsatCharac of data2[0].default.UsatCharac'>
              <div class="card">
                <div class="card-header" id="{{UsatCharac.idHeading}}">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse"
                      [attr.data-target]="'#' + UsatCharac.idCollapse" [attr.aria-expanded]="UsatCharac.expanded"
                      [attr.aria-controls]="UsatCharac.idCollapse">
                      {{UsatCharac.tituloKr}}
                    </button>
                  </h2>
                </div>

                <div id="{{UsatCharac.idCollapse}}" class="collapse {{UsatCharac.show}}"
                  [attr.aria-labelledby]="UsatCharac.idHeading" data-parent="#accordionExample">
                  <div class="card-body">
                    {{UsatCharac.descripcionKr}}
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingSeven">
                  <h2 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseSeven"
                      aria-expanded="true" aria-controls="collapseSeven">
                      기술 사양
                    </button>
                  </h2>
                </div>

                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                  <div class="card-body">
                    <table class=" table table-bordered table-hover">
                      <tr>
                        <th scope="">기능</th>
                        <th scope="">설명</th>
                      </tr>

                      <tr *ngFor='let tabla of data.default.tablaUsat'>
                        <th scope="">{{tabla.tCaracteristica1Kr}}</th>
                        <td scope="">{{tabla.tEspecificacion1Kr}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>



    <!-- Contenedor GIF -->
    <div class="col-lg-6 col-12 carouselG">
      <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel">
        <div class="carousel-inner ">
          <div *ngFor='let UsatGif of data.default.UsatGif'
            class=" border-Ca carousel-item {{UsatGif.activo}} p-3 mb-5 bg-white rounded">
            <img src="{{UsatGif.imagen}}" class="d-block w-90" alt="{{UsatGif.nombre}}">
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>

  </div>


  <div class="row cards-des">
    <div *ngFor='let Usat of data.default.Usat' class="col-xl-3 col-lg-3 col-md-3 col-12" [ngClass]="'InfoClass'">
      <div class="card card-cascade text-white bg-orange mb-3 cards-h ">
        <!-- Card image -->
        <div class="view view-cascade overlay mr-img">
          <img class="card-img-top" src="{{Usat.imagen}}" alt="Card image cap">
          <a>
            <div class="mask rgba-white-slight"></div>
          </a>
        </div>

        <!-- Card content -->
        <div class="card-body card-body-cascade text-center" [ngSwitch]="idioma">

          <!-- Caso para idioma en ingles -->
          <ng-container *ngSwitchCase="2">
            <!-- Title -->
            <h4 class="card-title"><strong>{{Usat.tituloIn}}</strong></h4>
            <!-- Subtitle -->
            <hr>
            <!-- Text -->
            <p class="card-text">{{Usat.descriptionIn}}</p>
          </ng-container>

          <!-- Caso para idioma en chino -->
          <ng-container *ngSwitchCase="3">
            <!-- Title -->
            <h4 class="card-title"><strong>{{Usat.tituloZh}}</strong></h4>
            <!-- Subtitle -->
            <hr>
            <!-- Text -->
            <p class="card-text">{{Usat.descriptionZh}}</p>
          </ng-container>
          <!-- Caso para idioma en Español -->
          <ng-container *ngSwitchDefault>
            <!-- Title -->
            <h4 class="card-title"><strong>{{Usat.titulo}}</strong></h4>
            <!-- Subtitle -->
            <hr>
            <!-- Text -->
            <p class="card-text">{{Usat.descripcion}}</p>
          </ng-container>
          <!-- Caso para idioma en frances -->
          <ng-container *ngSwitchCase="4">
            <!-- Title -->
            <h4 class="card-title"><strong>{{Usat.tituloFr}}</strong></h4>
            <!-- Subtitle -->
            <hr>
            <!-- Text -->
            <p class="card-text">{{Usat.descriptionFr}}</p>
          </ng-container>
          <!-- Caso para idioma en Aleman -->
          <ng-container *ngSwitchCase="5">
            <!-- Title -->
            <h4 class="card-title"><strong>{{Usat.tituloDe}}</strong></h4>
            <!-- Subtitle -->
            <hr>
            <!-- Text -->
            <p class="card-text">{{Usat.descriptionDe}}</p>
          </ng-container>
          <!-- Caso para idioma en Ruso -->
          <ng-container *ngSwitchCase="6">
            <!-- Title -->
            <h4 class="card-title"><strong>{{Usat.tituloRu}}</strong></h4>
            <!-- Subtitle -->
            <hr>
            <!-- Text -->
            <p class="card-text">{{Usat.descriptionRu}}</p>
          </ng-container>
          <!-- Caso para idioma en Portugués Brasil -->
          <ng-container *ngSwitchCase="7">
            <!-- Title -->
            <h4 class="card-title"><strong>{{Usat.tituloBr}}</strong></h4>
            <!-- Subtitle -->
            <hr>
            <!-- Text -->
            <p class="card-text">{{Usat.descriptionBr}}</p>
          </ng-container>
          <ng-container *ngSwitchCase="8">
            <!-- Title -->
            <h4 class="card-title"><strong>{{Usat.tituloKr}}</strong></h4>
            <!-- Subtitle -->
            <hr>
            <!-- Text -->
            <p class="card-text">{{Usat.descriptionKr}}</p>
          </ng-container>
          <!-- Facebook -->
        </div>
        <!-- Card footer  -->
      </div>
    </div>
  </div>
</aside>